import { render, staticRenderFns } from "./WidgetTournamentAutoSettings.vue?vue&type=template&id=208660c1&scoped=true&"
import script from "./WidgetTournamentAutoSettings.vue?vue&type=script&lang=js&"
export * from "./WidgetTournamentAutoSettings.vue?vue&type=script&lang=js&"
import style0 from "./WidgetTournamentAutoSettings.vue?vue&type=style&index=0&id=208660c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208660c1",
  null
  
)

export default component.exports